<template>
</template>

<script type="text/ecmascript-6">
import { getToken } from '@/common/js/auth.js'
import { mapMutations, mapGetters } from 'vuex'
import storage from 'good-storage'
const USER = '__user__'

export default {
  name: 'mixin',
  created () {
    // 如果有token，那么将token设置在vuex里面
    if (getToken()) {
      if (!this.user) {
        // 将storage里面的内容保存到vuex里面
        this.setStoreUser(storage.get(USER))
        this.setUserId(storage.get(USER).id)
      }
    }
  },
  methods: {
    ...mapMutations({
      setStoreUser: 'SET_USER',
      setUserId: 'SET_USERID'
    })
  },
  computed: {
    ...mapGetters(['user'])
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mixin/mixin.vue